import axios from 'axios';
import md5 from 'js-md5';
import Qs from 'qs';
import Fingerprint2 from 'fingerprintjs2';
import router from '../router'
import store from '../store'
import {
	addCookie,
	getCookie,
	delCookie
} from '../assets/js/cookie.js';

//排序
function objKeySort(obj) {
	var newkey = Object.keys(obj).sort();
	var newObj = {};
	for (var i = 0; i < newkey.length; i++) {
		newObj[newkey[i]] = obj[newkey[i]];
	}
	return newObj;
}
//拼接
function genSign(obj, apikey) {
	if (obj.sign) {
		delete obj.sign;
	}
	var str = "";
	var newkey = Object.keys(obj);
	for (var i = 0; i < newkey.length; i++) {
		str += newkey[i] + '=' + obj[newkey[i]];
	}
	str += apikey;
	return str;
}
// 加密
function signfunct(param) {
	var signs = postFun.key;
	var ret = objKeySort(param); //函数执行
	var sign = genSign(ret, signs);
	sign = md5(sign);
	return sign;
}

function getQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return decodeURI(r[2]);
	return null;
}


function tokenOut() {
	let userAgent = navigator.userAgent;
	if (userAgent.indexOf('h5native_ios') != -1) {
		window.webkit.messageHandlers.logout.postMessage('111');
	} else if (userAgent.indexOf('platform/h5native_android') != -1) {
		MKWebCenterActivity.logout();
	}
}

function gtag_config() {
	gtag('js', new Date());
	gtag('config', 'AW-16575334909');
}


function gtag_report_conversion_ps(url, ps) {
	console.log(ps);
	gtag_report_conversion();
}






function detectDevice() {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// 优先判断是否为iPad
	if (/iPad/i.test(userAgent)) {
		return "1";
	}

	// 接着判断是否为iPhone
	if (/iPhone/i.test(userAgent)) {
		return "1";
	}

	// 判断是否为Android设备
	if (/Android/i.test(userAgent)) {
		return "2";
	}

	// 如果以上都不匹配，则假定为PC
	return "3";
}



let postFun = {
	key: '452f0fe6b7a412826ad1ffd2c9ee9add',
	detectDevice() {
		var browser = {
			versions: function() {
				var u = navigator.userAgent,
					app = navigator.appVersion;
				return { //移动终端浏览器版本信息 
					trident: u.indexOf('Trident') > -1, //IE内核
					presto: u.indexOf('Presto') > -1, //opera内核
					webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
					gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
					mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
					ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
					android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
					iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
					iPad: u.indexOf('iPad') > -1, //是否iPad
					webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
				};
			}(),
			language: (navigator.browserLanguage || navigator.language).toLowerCase()
		}
		var hrefElement = document.getElementById('href');
		if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
			return "1";
		} else {
			return "2";
		}
	},
	iosrefer(name) {
		// console.log(name);
		
		if (name == 'pre07v2') {
			store.state.languageData.ioslink =
				'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=bf875f2d-dc61-4d14-adcf-6643d496505a';
		} else if (name == 'pre07') {
			store.state.languageData.ioslink =
				'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=01d099c1-b17b-4e45-bf96-8f09bb6970cd';
		} else if (name == 'pre1') {
			if (getQueryString('ss') == 'Google') {
				store.state.languageData.ioslink =
					'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=26cfe914-6ed0-4610-b793-25647da19df1';
			} else if (getQueryString('ss') == 'Facebook') {
				store.state.languageData.ioslink =
					'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=7b09d7fc-e2a3-4c72-9b60-14207ad63a25';
			} else if (getQueryString('ss') == 'Tiktok') {
				store.state.languageData.ioslink =
					'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=8dec966e-9cbc-4aba-b1ba-28856a9572a4';
			}

		} else if (name == 'pre2') {
			store.state.languageData.ioslink =
				'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=7108fc57-b8e8-431a-ba68-9dbd51d9d811';
		} else if (name == 'pre08') {
			if (getQueryString('ss') == 'Google') {
				store.state.languageData.ioslink =
					'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=2cb9f91d-f4cd-419b-940b-2701988dcfa4';
			} else if (getQueryString('ss') == 'Facebook') {
				store.state.languageData.ioslink =
					'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=980ac965-a0c8-46e0-8500-e0ed86558b9f';
			} else if (getQueryString('ss') == 'Tiktok') {
				store.state.languageData.ioslink =
					'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=6d7db837-4e50-4866-b388-827e307c55fc';
			}
		} else if (name == 'pre09') {
			store.state.languageData.ioslink =
				'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=928e6a40-437c-42a2-833e-ac5f5e63f5f1';
		} else if (name == 'pre10') {
			store.state.languageData.ioslink =
				'https://apps.apple.com/us/app/幽遊白書-激鬥/id6482995168?ppid=5ab31849-ec11-42e4-b3b5-047087c55b09';
		}  
	},
	topart(id) {
		var element = document.getElementById(id);
		// 滚动到该元素，第二个参数是{behavior: "smooth"}用于平滑滚动
		element.scrollIntoView({
			behavior: "smooth"
		});
		// this.hanbager = false;
	},
	lufun() {
		let currentDanmuIndex = 0;
		const danmuMessages = store.state.danMu;
		let num = true;
		// console.log(danmuMessages.length)
		startDanmu();

		function createDanmu(message) {
			const danmuElement = document.createElement('div');
			danmuElement.classList.add('danmu');
			danmuElement.textContent = message.nickname + '：';
			danmuElement.style.right = '0%';
			if (!num) {
				danmuElement.style.bottom = '35px';
			}
			document.getElementById('danmu-container').appendChild(danmuElement);
			const danmuElement2 = document.createElement('span');
			danmuElement2.textContent = message.content;
			danmuElement2.style.right = '0%';
			danmuElement.appendChild(danmuElement2);
			setTimeout(function() {
				danmuElement.remove()
			}, 10000)
		}

		function getRandomInt(n) {
			return Math.floor(Math.random() * n);
		}

		function startDanmu() {
			createDanmu(danmuMessages[currentDanmuIndex++]);
			const interval = setInterval(() => {
				num = !num;
				if (currentDanmuIndex >= danmuMessages.length) {
					currentDanmuIndex = 0; // 重置索引以实现循环播放
				}
				createDanmu(danmuMessages[currentDanmuIndex++]);
			}, 5000); // 每3秒生成一条新弹幕

			// 如果需要停止弹幕，可以调用clearInterval(interval)，但这里未提供停止按钮
		}
	},
	lufun2() {
		let currentDanmuIndex = 0;
		const danmuMessages = store.state.danMu;
		// console.log(danmuMessages.length)
		let num2 = true;
		startDanmu()

		function createDanmu(message) {
			const danmuElement = document.createElement('div');
			danmuElement.classList.add('danmu-pc');
			danmuElement.textContent = message.nickname + '：';
			danmuElement.style.right = '0%';
			if (!num2) {
				danmuElement.style.bottom = '35px';
			}
			document.getElementById('danmu-container-pc').appendChild(danmuElement);
			const danmuElement2 = document.createElement('span');
			danmuElement2.textContent = message.content;
			danmuElement2.style.right = '0%';
			danmuElement.appendChild(danmuElement2);
			setTimeout(function() {
				danmuElement.remove()
			}, 10000)
		}

		function getRandomInt(n) {
			return Math.floor(Math.random() * n);
		}

		function startDanmu() {
			createDanmu(danmuMessages[currentDanmuIndex++]);
			const interval = setInterval(() => {
				num2 = !num2;
				if (currentDanmuIndex >= danmuMessages.length) {
					currentDanmuIndex = 0; // 重置索引以实现循环播放
				}
				createDanmu(danmuMessages[currentDanmuIndex++]);
			}, 5000); // 每3秒生成一条新弹幕

			// 如果需要停止弹幕，可以调用clearInterval(interval)，但这里未提供停止按钮
		}
	},
	mysgfun() {
		postFun.trackingfun('click_test_all');
		if (router.currentRoute.name == 'sg_tc_01') {
			window.open('https://forms.gle/LGcV731wH9kePcD47');
		} else if (router.currentRoute.name == 'sg_tc_02') {
			window.open('https://forms.gle/3yThQM9aoSKMrdfm9');
		} else if (router.currentRoute.name == 'sg_en_01') {
			window.open('https://forms.gle/Rz3xjx5UpBwNYJk2A');
		} else if (router.currentRoute.name == 'sg_en_02') {
			window.open('https://forms.gle/ZhEmXC6aZuc6oUmP6');
		} else if (router.currentRoute.name == 'my_tc_01') {
			window.open('https://forms.gle/kx4AFVLVYUeesuMf6');
		} else if (router.currentRoute.name == 'my_tc_02') {
			window.open('https://forms.gle/SQa38h6rJJ98K5gp9');
		} else if (router.currentRoute.name == 'my_en_01') {
			window.open('https://forms.gle/pnNEsXMGjpj2iv248');
		} else if (router.currentRoute.name == 'my_en_02') {
			window.open('https://forms.gle/xUsymuvriDFJakxr9');
		}
	},
	taskfun(type) {
		let this_ = this;
		let p = {
			token: store.state.token,
			task_type: type
		}
		let url = "task";
		postFun.axiosfun(p, url).then((res) => {
			console.log(res);
			if (res.code == 0) {
				store.state.drawNumber = res.data.drawNumber;
				store.state.task = res.data.task;
			}
		}).catch((res) => {
			console.log(res);
		})
	},
	trackingfun(event) {
		let params = {
			event: event
		}

		postFun.axiosfun(params, "event").then((res) => {
			if (getQueryString('ss') == 'Facebook'  || getQueryString('ss') == 'sns' || getQueryString('ss') == ''|| getQueryString('ss') == null) {
				fbq('trackCustom', params.event, {}, {
					eventID: res.data.event_id
				});
			} else if (getQueryString('ss') == 'Tiktok') {
				ttq.track(params.event);
			}

			if (router.currentRoute.name == 'pre') {
				gtag('event', params.event, {
					'send_to': 'G-7131GK1NZE'
				});
			} else if (router.currentRoute.name == 'pre1') {
				gtag('event', params.event, {
					'send_to': 'G-KWD5SECYX6'
				});
			} else if (router.currentRoute.name == 'pre2') {
				gtag('event', params.event, {
					'send_to': 'G-Z1GPN2XS19'
				});
			} else if (router.currentRoute.name == 'pre07' || router.currentRoute.name == 'pre07v2') {
				gtag('event', params.event, {
					'send_to': 'G-PVHTE7S35T'
				});
			} else if (router.currentRoute.name == 'pre08') {
				gtag('event', params.event, {
					'send_to': 'G-1SR15MM80D'
				});
			} else if (router.currentRoute.name == 'pre09') {
				gtag('event', params.event, {
					'send_to': 'G-WZYYTE9KK8'
				});
			} else if (router.currentRoute.name == 'pre10') {
				gtag('event', params.event, {
					'send_to': 'G-5MY82M2NR3'
				});
			}

			if (event.indexOf('gp') != -1 || event.indexOf('ios') != -1) {
				postFun.taskfun('task_store')
			}
		}).catch((res) => {
			console.log(res);
		})

	},
	axiosfun(params, url) {
		return new Promise((resolve, reject) => {
			Fingerprint2.get(function(components) {
				// console.log(router)
				// result 是一个包含浏览器指纹信息的对象
				//console.log(components); // 输出到控制台以查看内容
				// 在这里，你可以根据需要将 result 发送到服务器
				const values = components.map(function(component, index) {
					if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
						return component.value.replace(/\bNetType\/\w+\b/, '')
					}
					return component.value
				})

				const murmur = Fingerprint2.x64hash128(values.join(''), 31);
				// console.log(murmur);
				let protocolStr = document.location.protocol;
				let hosturl = window.location.host;
				var urlhost = 'https://sdk-tc.zenifun.com/PreReg/yybs/gat/';
				const ss = getQueryString('ss') || '';
				const ts = getQueryString('ts') || '';
				let userAgent = navigator.userAgent;
				let evId = murmur + Date.now();
				evId = md5(evId);
				// console.log(router.currentRoute);
				let paramss = {
					...router.currentRoute.query,
					...params,
					gid: 1,
					sgid: 8,
					ss: ss,
					ts: ts,
					requestTime: Date.now().toString().substring(0, 10),
					ua: userAgent,
					host: window.location.href,
					device_id: murmur,
					device_type: detectDevice(),
					event_id: evId,
					language: store.state.lagCode,
					ps: router.currentRoute.name || 'ps1'
				}
				// console.log(params);
				let key = signfunct(paramss);
				paramss.requestSign = key;
				axios({
					method: 'post',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
					},
					url: '' + urlhost + url + '',
					data: Qs.stringify(paramss)
				}).then(res => {
					// console.log(res);
					// console.log( getQueryString('ss'))
					if (res.data.code == 0) {
						resolve(res.data);
						if (paramss.event) {
							if (paramss.event.indexOf('phone_success') != -1 ) {
								if (router.currentRoute.name == 'pre') {
									gtag('event', 'Purchase', {
										'send_to': 'G-7131GK1NZE'
									});
								} else if (router.currentRoute.name == 'pre1') {
									gtag('event', 'Purchase', {
										'send_to': 'G-KWD5SECYX6'
									});
								} else if (router.currentRoute.name == 'pre2') {
									gtag('event', 'Purchase', {
										'send_to': 'G-Z1GPN2XS19'
									});
								} else if (router.currentRoute.name == 'pre07' || router
									.currentRoute.name == 'pre07v2') {
									gtag('event', 'Purchase', {
										'send_to': 'G-PVHTE7S35T'
									});
								} else if (router.currentRoute.name == 'pre08') {
									gtag('event', 'Purchase', {
										'send_to': 'G-1SR15MM80D'
									});
								} else if (router.currentRoute.name == 'pre09') {
									gtag('event', 'Purchase', {
										'send_to': 'G-WZYYTE9KK8'
									});
								} else if (router.currentRoute.name == 'pre10') {
									gtag('event', 'Purchase', {
										'send_to': 'G-5MY82M2NR3'
									});
								}
								gtag('set', 'user_data', {
									"phone_number": paramss.phone
								});
								gtag('event', 'conversion', {
									'send_to': 'AW-16660955152/wkGgCJrztNEZEJCAyIg-'
								});
								gtag('event', 'CompleteRegistration', {
									'send_to': 'AW-16660955152/wkGgCJrztNEZEJCAyIg-'
								});
								
								if (getQueryString('ss') == 'Facebook' || getQueryString('ss') == 'sns' || getQueryString('ss') == ''|| getQueryString('ss') == null) {
									if (res.data.data.is_new==1) {
										fbq('track', "CompleteRegistration", {}, {
											eventID: evId
										});
										fbq('track', "Purchase", {}, {
											eventID: evId
										});
									}
								} else if (getQueryString('ss') == 'Tiktok') {
									ttq.track("CompleteRegistration");
								}
							}
						}

					} else {
						reject(res.data)
					}

				}).catch(error => {
					console.log(error);
				})
			});



		})
	},
	locationOpen(ps) {
		if (getQueryString('ss') == 'Facebook') {
			window.open(
				''
			)
		} else if (getQueryString('ss') == 'Google') {
			window.open(
				''
			)

		} else if (getQueryString('ss') == 'Tiktok') {
			window.open(
				''
			)
		}

	}
}

export default postFun;